import styled, { keyframes } from 'styled-components';
import './styles.css';

type AddToHomeScreenProps = {
  isClosing: boolean;
  isAndroid: boolean;
};

const slideUp = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
`;

const slideDown = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(100%);
    }
`;

export const StyledAddToHomePageModal = styled.div<AddToHomeScreenProps>`
  font-family: 'Open Sans', sans-serif;
  width: 100%;
  background-color: var(--background-color);
  position: fixed;
  bottom: 0;
  z-index: 100;
  border-radius: ${({ isAndroid }) => (isAndroid ? 'none' : '15px 15px 0 0')};
  backdrop-filter: blur(8px);
  color: var(--text-color);
  animation: ${({ isClosing }) => (isClosing ? slideDown : slideUp)} 0.2s
    ease-out forwards;

  .container {
    margin: ${({ isAndroid }) => (isAndroid ? '16px' : '13px 16px 25px')};
    position: relative;

    .close-button {
      position: absolute;
      right: 0;
      top: ${({ isAndroid }) => (isAndroid ? 0 : '4px')};
      padding: 0;

      &--icon {
        color: var(--text-color);
      }
    }

    .company-info {
      font-weight: 600;
      font-style: normal;
      line-height: 1.5;
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
      align-items: end;

      &--logo {
        height: 40px;
        margin-bottom: 15px;
      }

      &--title {
        font-size: 14px;
        text-transform: uppercase;
        margin: 0 0 4px 0;
      }

      &--description {
        font-size: 10px;
        margin: 0;
      }
    }

    .guide {
      font-size: 14px;
      font-style: normal;
      line-height: 1.5;
      width: 100%;

      &-divider {
        background: #7b7b7b;
        border-bottom-width: 0.5px;
      }

      &-description {
        font-weight: 400;
        margin: 16px 0;
      }

      &-list {
        padding: 0;
        margin-top: 16px;
        margin-bottom: 0;

        &--item {
          font-weight: 600;
          display: flex;
          align-items: center;

          &:not(:last-child) {
            margin-bottom: 16px;
          }

          &__icon {
            margin-right: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 24px;
            height: 24px;
          }

          .fa-arrow-up-from-bracket {
            font-size: 1rem;
          }

          .fa-square-plus {
            font-size: 18px;
          }
        }
      }
    }
  }
` as any;
